import { render } from "./vweipagespreview.vue?vue&type=template&id=385cb2aa&scoped=true"
import script from "./vweipagespreview.vue?vue&type=script&lang=js"
export * from "./vweipagespreview.vue?vue&type=script&lang=js"

import "./vweipagespreview.vue?vue&type=style&index=0&id=385cb2aa&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385cb2aa"]])

export default __exports__